import React, { useEffect, useState, useRef } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { useParams } from 'react-router'
import { getSurgeon } from '../../store/action/surgeon.action'
import '../../css/surgeon.page.scss'
import {
  Button,
  Col,
  Collapse,
  Divider,
  Input,
  Row,
  Spin,
  Form,
  message,
} from 'antd'
import location from '../../images/location.svg'
import Call from '../../images/call.svg'
import Message from '../../images/message.svg'
import Mail from '../../images/mail.svg'
import Info from '../../images/info.svg'
import SwipeableBottomSheet from 'react-swipeable-bottom-sheet'
import { DownloadOutlined, UserAddOutlined } from '@ant-design/icons'
import PhoneInput, {
  formatPhoneNumberIntl,
  isValidPhoneNumber,
} from 'react-phone-number-input'
import 'react-phone-number-input/style.css'
import serviceInterface from '../../services/service.interface'
import util, { OS_TYPES } from '../../util/util'
import { addCallback } from '../../store/action/callback.action'
import moment from 'moment'
import profilelogo from '../../images/profile.jpg'
const DRAWER_TYPE = {
  INFO: 'INFO',
  FORM: {
    PATIENT: 'PATIENT',
    OUTSIDER: 'OUTSIDER',
  },
}

const DRAWER_SWITCH_DELAY = 310

const Surgeon = (props) => {
  var form = useRef()
  const surgeonid = useParams().id
  const patientid = useParams().patientid
  const [showDrawer, setDrawer] = useState(false)
  const [drawertype, setDrawertype] = useState(DRAWER_TYPE.INFO)

  useEffect(() => {
    props.fetchSurgeon(surgeonid)
  }, [])

  var smsClick = (number) => openUrlAndroid('sms:' + number)
  var telClick = (number) => openUrlAndroid('tel:' + number)
  var mailClick = (email) => openUrlAndroid('mailto:' + email)

  var formatNumber = (phone) => {
    var number = phone ? phone.toString() : undefined
    if (number) {
      if (number.length > 10)
        number = number?.charAt(0) == '+' ? number : '+' + number
      else number = number?.charAt(0) == '+' ? '1' + number : '+1' + number
      return number
    }
    return ''
  }
  const openUrlAndroid = (data) => {
    var OS = util.getOS()
    if (OS == OS_TYPES.ANDROID || OS == OS_TYPES.IOS) {
      window.ReactNativeWebView.postMessage(
        JSON.stringify({ route: '/openurl', data })
      )
    } else window.location.href = data
  }

  var sendVcfToMobile = (OS) => {
    serviceInterface
      .SurgeonService()
      .getVcf(surgeonid, props.surgeon?.name + '.vcf', false)
      .then((blob) => {
        var reader = new FileReader()
        reader.readAsDataURL(blob)
        reader.onloadend = function () {
          var ts = new Date().getTime().toString()
          var data = {
            data: reader.result,
            fileName:
              props.surgeon?.name?.split(' ')?.join('_') +
              '_' +
              ts.substr(ts.length - 5) +
              '.vcf',
          }
          if (OS == OS_TYPES.ANDROID || OS == OS_TYPES.IOS)
            window.ReactNativeWebView.postMessage(
              JSON.stringify({ route: '/vcf', data })
            )
          else window.top.postMessage({ route: '/downloadvcf', data }, '*')
        }
      })
  }

  var saveVcf = () => {
    var OS = util.getOS()
    if (patientid && (OS == OS_TYPES.ANDROID || OS == OS_TYPES.IOS))
      sendVcfToMobile(OS)
    else
      serviceInterface
        .SurgeonService()
        .getVcf(surgeonid, props.surgeon?.name + '.vcf')
  }

  var hideTeams = () => {
    for (var i = 0; i < props.surgeon?.team?.length; i++)
      if (
        props.surgeon?.team[i].details &&
        props.surgeon?.team[i].details.trim() != ''
      )
        return false
    return true
  }

  const handleDrawerChange = (isOpen) => {
    setDrawer(isOpen)
    setTimeout(() => {
      setDrawertype(DRAWER_TYPE.INFO)
    }, DRAWER_SWITCH_DELAY)
  }

  const handleDrawerSwitch = (type) => {
    setDrawer(false)
    setTimeout(() => {
      setDrawer(true)
      if (type == DRAWER_TYPE.INFO) setDrawertype(DRAWER_TYPE.INFO)
      else if (patientid) setDrawertype(DRAWER_TYPE.FORM.PATIENT)
      else setDrawertype(DRAWER_TYPE.FORM.OUTSIDER)
    }, DRAWER_SWITCH_DELAY)
  }

  const download_back_click = (event) => {
    if (drawertype === DRAWER_TYPE.INFO) return saveVcf()
    handleDrawerSwitch(DRAWER_TYPE.INFO)
  }

  const request_submit_click = (event) => {
    if (drawertype === DRAWER_TYPE.INFO) return handleDrawerSwitch()
    form.current.submit()
  }

  var handleFormSubmit = (values) => {
    props
      .addCallback(patientid, { ...values, surgeon: surgeonid })
      .then((response) => {
        if (response) {
          handleDrawerChange(false)
          message.success("I'll call you back asap.")
          form.current.resetFields()
        }
        // console.log(response.receivedon);
        // console.log(moment(moment.utc(response.receivedon).toDate()).local().format("DD/MM/YYYY hh:mm a"));
      })
  }

  var renderTeam = () => {
    return props.surgeon?.team?.map((v, i) => {
      return v.details && v.details.trim() != '' ? (
        <Collapse.Panel header={v.name} key={i + 1}>
          <p className='collapse-details'>{v.details}</p>
        </Collapse.Panel>
      ) : null
    })
  }

  var renderInfoDrawer = () => {
    var OS = util.getOS()
    var btn_color =
      patientid && (OS == OS_TYPES.ANDROID || OS == OS_TYPES.IOS)
        ? ['rgb(245,146,31)', '#012448']
        : []
    return (
      <div style={{ minHeight: '240px' }}>
        <div className='drawer-handle'></div>
        <Row className='drawer-body'>
          <Col flex='auto'>
            <Row align='middle' className='drawer-header'>
              <Col hidden={drawertype !== DRAWER_TYPE.INFO}>
                <div className='drawer-preview-img'>
                  <img src={props.surgeon.image || profilelogo} />
                </div>
              </Col>
              <Col className='drawer-name' flex='auto'>
                {drawertype === DRAWER_TYPE.INFO
                  ? props.surgeon.name
                  : 'Request Callback'}
              </Col>
            </Row>
            <div hidden={drawertype !== DRAWER_TYPE.INFO}>
              <Row
                hidden={!props.surgeon?.phone?.private}
                align='middle'
                className='drawer-sub'
              >
                <Col flex='auto'>
                  <Row className='drawer-sub-header'>Mobile</Row>
                  <Row className='drawer-sub-descp'>
                    {formatPhoneNumberIntl(
                      formatNumber(props.surgeon?.phone?.private)
                    )}
                  </Row>
                </Col>
                <Col style={{ marginLeft: 'auto', color: 'black' }}>
                  <img
                    className='sp-icon'
                    onClick={() =>
                      telClick(formatNumber(props.surgeon?.phone?.public))
                    }
                    width='24'
                    height='24'
                    src={Call}
                  />
                </Col>
                <Col>
                  <img
                    className='sp-icon'
                    onClick={() =>
                      smsClick(formatNumber(props.surgeon?.phone?.public))
                    }
                    width='24'
                    height='24'
                    src={Message}
                  />
                </Col>
              </Row>
              <Divider style={{ margin: 0 }} />
              <Row
                hidden={!props.surgeon?.email}
                align='middle'
                className='drawer-sub'
              >
                <Col flex='auto'>
                  <Row className='drawer-sub-header'>Email</Row>
                  <Row className='drawer-sub-descp'>{props.surgeon?.email}</Row>
                </Col>
                <Col style={{ marginLeft: 'auto', color: 'black' }}>
                  <img
                    className='sp-icon'
                    onClick={() => mailClick(props.surgeon?.email)}
                    width='24'
                    height='24'
                    src={Mail}
                  />
                </Col>
              </Row>
              <Divider style={{ margin: 0 }} />
              <Row align='middle' className='drawer-sub'>
                <Col flex='auto'>
                  <Row className='drawer-sub-header'>Work</Row>
                  <Row className='drawer-sub-descp'>
                    <Col>
                      {formatPhoneNumberIntl(
                        formatNumber(props.surgeon?.phone?.public)
                      )}
                    </Col>
                  </Row>
                </Col>
                <Col style={{ marginLeft: 'auto', color: 'black' }}>
                  <img
                    className='sp-icon'
                    onClick={() =>
                      telClick(formatNumber(props.surgeon?.phone?.public))
                    }
                    width='24'
                    height='24'
                    src={Call}
                  />
                </Col>
                <Col hidden>
                  <img
                    className='sp-icon'
                    onClick={() =>
                      smsClick(formatNumber(props.surgeon?.phone?.public))
                    }
                    width='24'
                    height='24'
                    src={Message}
                  />
                </Col>
              </Row>
              <Divider style={{ margin: 0 }} />
            </div>
            <div hidden={drawertype === DRAWER_TYPE.INFO}>
              <Form
                ref={form}
                initialValues={{ phone: '' }}
                onFinish={handleFormSubmit}
              >
                <Row
                  align='middle'
                  className='drawer-sub'
                  style={{ padding: 0 }}
                >
                  <Col flex='auto'>
                    <Row
                      hidden={drawertype == DRAWER_TYPE.FORM.PATIENT}
                      className='drawer-sub-header'
                    >
                      <span style={{ color: 'red' }}>*</span>Phone
                    </Row>
                    {drawertype !== DRAWER_TYPE.FORM.PATIENT && (
                      <Row
                        hidden={drawertype == DRAWER_TYPE.FORM.PATIENT}
                        className='drawer-sub-descp'
                      >
                        <Form.Item
                          className='drawer-form-item'
                          name='phone'
                          rules={[
                            { required: true },
                            () => ({
                              validator(rule, value) {
                                var number = value
                                  ? value.charAt(0) == '+'
                                    ? value
                                    : '+' + value
                                  : ''
                                if (!value || isValidPhoneNumber(number)) {
                                  return Promise.resolve()
                                }
                                return Promise.reject(
                                  'Please enter valid number!'
                                )
                              },
                            }),
                          ]}
                        >
                          <PhoneInput
                            form
                            autoFocus
                            defaultCountry={'US'}
                            className='drawer-input drawer-phone-input'
                            enableAreaCodes
                          />
                        </Form.Item>
                      </Row>
                    )}
                    <Row
                      hidden={drawertype == DRAWER_TYPE.FORM.PATIENT}
                      className='drawer-sub-header'
                    >
                      <span style={{ color: 'red' }}>*</span>Name
                    </Row>
                    {drawertype !== DRAWER_TYPE.FORM.PATIENT && (
                      <Row
                        hidden={drawertype == DRAWER_TYPE.FORM.PATIENT}
                        className='drawer-sub-descp'
                      >
                        <Form.Item
                          className='drawer-form-item'
                          name='name'
                          rules={[{ required: true }]}
                        >
                          <Input className='drawer-input' />
                        </Form.Item>
                      </Row>
                    )}
                    <Row className='drawer-sub-header'>
                      <span style={{ color: 'red' }}>*</span>Message (max 500
                      characters)
                    </Row>
                    <Row className='drawer-sub-descp'>
                      <Form.Item
                        className='drawer-form-item'
                        style={{ marginBottom: 0 }}
                        name='message'
                        rules={[{ required: true }]}
                      >
                        <Input.TextArea
                          maxLength={500}
                          className='drawer-input'
                          rows={5}
                        />
                      </Form.Item>
                    </Row>
                  </Col>
                </Row>
              </Form>
            </div>
            <Row className='divider-dwn-row'>
              {/* <Button 
                                style={{marginBottom: 8, 
                                    backgroundColor: btn_color.length > 0 ? btn_color[0] : undefined,
                                    borderColor: btn_color.length > 0 ? btn_color[0] : undefined, }} 
                                onClick={request_submit_click} 
                                type="primary" block 
                            >
                                { drawertype !== DRAWER_TYPE.INFO ? "SUBMIT" :  "REQUEST CALLBACK" }
                            </Button> */}
              <Button
                onClick={download_back_click}
                type='primary'
                block
                danger={drawertype !== DRAWER_TYPE.INFO}
                style={{
                  backgroundColor:
                    btn_color.length > 0
                      ? drawertype !== DRAWER_TYPE.INFO
                        ? btn_color[1]
                        : btn_color[0]
                      : undefined,
                  borderColor:
                    btn_color.length > 0
                      ? drawertype !== DRAWER_TYPE.INFO
                        ? btn_color[1]
                        : btn_color[0]
                      : undefined,
                }}
              >
                {drawertype !== DRAWER_TYPE.INFO ? 'BACK' : 'DOWNLOAD CONTACT'}
              </Button>
            </Row>
          </Col>
        </Row>
      </div>
    )
  }

  return (
    <div className='surgeon-page-container'>
      <div className='surgeon-page'>
        <Spin spinning={props.isLoading}>
          <Row justify='center' align='middle' className='cover-box'>
            <img src={props.surgeon.image || profilelogo} />
          </Row>
          <Row className='sp-body'>
            <Col flex='auto'>
              <Row className='sp-name'>{props.surgeon.name}</Row>
              <Row hidden={!props.surgeon.url} className='sp-url'>
                <p>{props.surgeon.url}</p>
              </Row>
              <Row
                hidden={
                  !(
                    props.surgeon.department_title ||
                    props.surgeon.department_name ||
                    props.surgeon.hospital_name
                  )
                }
                style={{ flexWrap: 'nowrap' }}
              >
                <Col flex='23px'>
                  <img width='15' height='15' src={Info} />
                </Col>
                <Col flex='auto' className='sp-address'>
                  <span hidden={!props.surgeon.department_title}>
                    {props.surgeon.department_title}
                  </span>
                  <span hidden={!props.surgeon.department_name}>
                    ,&nbsp;{props.surgeon.department_name}
                  </span>{' '}
                  <br />
                  <span hidden={!props.surgeon.hospital_name}>
                    {props.surgeon.hospital_name}
                  </span>
                </Col>
              </Row>
              <Row
                hidden={!props.surgeon.address}
                style={{ flexWrap: 'nowrap' }}
              >
                <Col flex='23px'>
                  <img width='15' height='15' src={location} />
                </Col>
                <Col flex='auto' className='sp-address'>
                  {props.surgeon.address}
                </Col>
              </Row>
              <Divider></Divider>
              <Row
                style={{ marginBottom: 32, flexWrap: 'nowrap' }}
                gutter={[10]}
              >
                <Col flex='85%'>
                  <Button
                    icon={<UserAddOutlined />}
                    className='sp-native-btn'
                    block
                    onClick={() => setDrawer(true)}
                  >
                    CONTACT ME
                  </Button>
                </Col>
                <Col flex='15%'>
                  <Button
                    onClick={() => saveVcf()}
                    icon={<DownloadOutlined />}
                    className='sp-native-btn'
                    block
                  ></Button>
                </Col>
              </Row>
              <Row
                hidden={
                  !(
                    props.surgeon.about_me &&
                    props.surgeon.about_me.trim() != ''
                  )
                }
              >
                <p className='sp-sub-header'> About Me </p>
              </Row>
              <Row
                hidden={
                  !(
                    props.surgeon.about_me &&
                    props.surgeon.about_me.trim() != ''
                  )
                }
                className='sp-about-me'
              >
                {props.surgeon.about_me}
              </Row>
              <Row
                hidden={
                  !(
                    props.surgeon.hospital_name &&
                    props.surgeon.hospital_name.trim() != '' &&
                    props.surgeon.hospital_url
                  )
                }
                style={{ marginTop: 32, marginBottom: 32 }}
              >
                <Button className='sp-native-btn' block>
                  <a href={props.surgeon.hospital_url}>
                    {props.surgeon.hospital_name}
                  </a>
                </Button>
              </Row>
              <Row hidden={hideTeams()}>
                <p className='sp-sub-header'> Team </p>
              </Row>
              <Row hidden={hideTeams()}>
                <Collapse
                  expandIconPosition={'right'}
                  style={{ width: '100%' }}
                >
                  {renderTeam()}
                </Collapse>
              </Row>
              <Row justify='center' align='middle' className='sp-footer'>
                {util.getCopyrightText()}
              </Row>
            </Col>
          </Row>
          <SwipeableBottomSheet
            style={{ zIndex: 9, maxWidth: '100%', borderRadius: 20 }}
            open={showDrawer}
            onChange={handleDrawerChange}
            overlayStyle={{ maxWidth: 530, margin: 'auto' }}
          >
            {renderInfoDrawer()}
          </SwipeableBottomSheet>
        </Spin>
      </div>
    </div>
  )
}

Surgeon.propTypes = {}

const mapStateToProps = (state) => {
  return {
    surgeon: state.surgeon.surgeon,
    isLoading: state.profile.isLoading,
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    fetchSurgeon: (surgeonid) => dispatch(getSurgeon(surgeonid)),
    addCallback: (patientid, request) =>
      dispatch(addCallback(patientid, request)),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Surgeon)
